module.exports = __webpack_public_path__ + "res/img_reward_b.b037d4538a21e08182c79fee0a344cbe.png";